import * as _ from 'lodash';
import { RegistrationReducer } from '../interfaces';
import { createReducer } from '@reduxjs/toolkit';

export const initialState: RegistrationReducer = {
  status: {
    loading: false,
    error: false,
    done: false,
  },
};

const registrationReducer = createReducer(initialState, {
  REGISTER_FULFILLED: (state, action) => {
    state.status = {
      loading: false,
      error: false,
      done: _.get(action, 'payload.data.message'),
    };
  },
  REGISTER_PENDING: (state) => {
    state.status = {
      loading: true,
      error: false,
      done: false,
    };
  },
  REGISTER_REJECTED: (state, action) => {
    state.status = {
      loading: false,
      error: _.get(action, 'payload.response.data.detail'),
      done: false,
    };
  },
});

export default registrationReducer;
